import React, { useContext, useMemo, useRef, useState } from 'react';
import styles from './styles.module.scss';
import { BasicDropDown } from '@components-clean/core/basic-dropdown';
import { formatDatasetDates, sortDatasetByDatesDesc } from '@components-clean/navbar/dataset-selector.utils';
import { CM2Dataset } from '@interfaces/central-monitoring';
import { StudySiteHubContext } from '@pages-clean/central-monitoring/interfaces/context';
import { useLocalState } from '@hooks/index';
import DatasetApi from '@apis/bff-api/central-monitoring/dataset';

const DatasetFilterSelector = () => {
    const anchor = useRef<HTMLDivElement | null>(null);
    const { current, setComparisonDataset } = useContext(StudySiteHubContext);
    const { data: datasets } = DatasetApi.useGetActive(current.studyRef);
    const { dispatch } = useLocalState();
    const sortedDatasets = (datasets ?? []).map(formatDatasetDates).sort(sortDatasetByDatesDesc);
    const [selectedDatasetId, setSelectedDatasetId] = useState<number>();

    const filteredDatasets = useMemo(() => {
        const filtered = sortedDatasets.filter(
            (d) =>
                d.id !== current?.dataset?.id &&
                new Date(d.dataCutDate as string) < new Date(current.dataset?.date ?? ''),
        );

        // Add the custom record at the start
        const customRecord = {
            id: -1,
            dataCutDate: 'Last Reviewed Dataset',
        };

        return [customRecord, ...filtered];
    }, [sortedDatasets, current]);

    const resetDatasetIds = () => {
        setSelectedDatasetId(0);
        setComparisonDataset(undefined);
        dispatch({
            type: 'SET_SELECTED_COMPARISON_CM2_DATASET',
            selectedComparisonCM2Dataset: null,
        });
    };

    return (
        <div ref={anchor} className="k-d-flex k-align-items-center">
            <BasicDropDown
                data-testid="comparison-dataset-selector"
                data={filteredDatasets}
                dataItemKey="id"
                textField="dataCutDate"
                value={filteredDatasets.find((d) => d.id === selectedDatasetId) ?? null}
                onChange={(e) => {
                    if (e.value) {
                        const dataset = e.value as CM2Dataset;
                        setSelectedDatasetId(dataset.id);
                        setComparisonDataset(dataset ?? undefined);
                        dispatch({
                            type: 'SET_SELECTED_COMPARISON_CM2_DATASET',
                            selectedComparisonCM2Dataset: dataset ?? null,
                        });
                    } else {
                        resetDatasetIds();
                    }
                }}
                filterable
                className={styles.subjectSelector}
                customClassName="basic-dropdown-styling"
                allowClear
                cardHeader
                type="card-header"
            />
        </div>
    );
};

export default DatasetFilterSelector;
